import { type JSONConfig, MeasurementKind } from '@/engine/app/interfaces.ts';
import { viewPorts } from './_common.config.ts';
import * as defaultObjectModel from './_viewObjects.config.ts';
import * as defaultViewOptionsModel from './_viewOptions.config.ts';
import * as defaultViewOptionsGroups from './_viewOptionsGroup.config.ts';
import { axial, coronal, sagittal } from '@/engine/common/imageSlices.config.ts';

export const config: JSONConfig.View = {
  descriptor: 'access',
  availabilityDescriptor: 'isAccessPlanningAvailable',
  label: 'Access',
  sideLabel: 'Access',
  imageStackDescriptor: 'Body',
  viewOrientationDescriptor: 'body_orientation',
  viewOptions: [
    {
      ...defaultViewOptionsGroups.anatomy,
      children: [
        defaultViewOptionsModel.veins,
        defaultViewOptionsModel.veinsCalcification,
        defaultViewOptionsModel.bones,
        defaultViewOptionsModel.filter,
        defaultViewOptionsModel.hardware,
        defaultViewOptionsModel.arteriesAndKidneys
      ]
    }
  ],
  objects: [
    defaultObjectModel.veinsCenterline,
    { ...defaultObjectModel.femoralVeinsCustomPlane, isPickable: true, isTunable: true, isEditingActivated: true },
    { ...defaultObjectModel.femoralVeinsLeftPoint, isPickable: true, isTunable: true, isEditingActivated: true },
    { ...defaultObjectModel.femoralVeinsRightPoint, isPickable: true, isTunable: true, isEditingActivated: true },
    { ...defaultObjectModel.centerlineReferencePoint, isPickable: true, isTunable: true, isEditingActivated: true },
    defaultObjectModel.arteriesKidneys,
    defaultObjectModel.veins,
    defaultObjectModel.veinsColored,
    defaultObjectModel.veinsCalcification,
    defaultObjectModel.bones,
    defaultObjectModel.filter,
    defaultObjectModel.hardware
  ],
  measurements: [
    {
      descriptor: 'tp.pl_right_femoral_vessel_min.area',
      isSelected: true,
      isPickable: true,
      isTunable: true,
      zoomFactor: 0.2
    },
    {
      descriptor: 'tp.pl_left_femoral_vessel_min.area',
      isPickable: true,
      isTunable: true,
      zoomFactor: 0.2
    },
    {
      descriptor: 'tp.pl_femoral_vessel_custom.area',
      isPickable: true,
      isTunable: true,
      isEditingActivated: true,
      zoomFactor: 0.2
    }
  ],
  centerLines: [
    {
      descriptor: 'vessel.right_centerline'
    },
    {
      descriptor: 'vessel.left_centerline'
    }
  ],
  activeCenterLineDescriptor: 'vessel.right_centerline',
  measurementBoxes: [
    {
      kind: MeasurementKind.AreaDiameter,
      label: 'Veins Diameters',
      entries: [
        'tp.pl_right_femoral_vessel_min.area',
        'tp.pl_left_femoral_vessel_min.area',
        'tp.pl_femoral_vessel_custom.area'
      ]
    }
  ],
  objectBoxes: [],
  workflowIndications: [],
  orientationPresets: [],
  tuneControls: [],
  imageSlices: [axial, coronal, sagittal],
  viewPorts,
  visibilityDependencies: [],
  selectionDependencies: [],
  helpers: [
    {
      descriptor: 'color_legend',
      details: {
        value: 'tp.catheterSize',
        range: 'catheter_allowance_factor_range'
      }
    }
  ]
};
